import { z } from "zod";

import { Value } from "./Value.ts";

export const NodeBindings = z.record(z.string(), Value);

export type NodeBindings = z.infer<typeof NodeBindings>;
